module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.footerVisible),
      expression: "footerVisible"
    }],
    staticClass: "footer",
    attrs: {
      "id": "footer"
    }
  }, [(_vm.dataList.length > 0) ? _c('Swipe', {
    staticClass: "footer-content",
    attrs: {
      "auto": -1
    }
  }, _vm._l((_vm.dataList), function(item) {
    return _c('Swipe-item', {
      key: "index",
      style: ({
        background: ("url(" + (item.bgImg) + ") no-repeat"),
        backgroundSize: "cover"
      })
    }, [_c('div', {
      staticClass: "footer-title"
    }, [_vm._v("\n                    " + _vm._s(item.title) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "footer-acceptBtn",
      style: ({
        background: ("url(" + (item.buttonImg) + ") no-repeat"),
        backgroundSize: "100%"
      }),
      on: {
        "click": function($event) {
          _vm.jumpLink(item.jumpType, item.buttonUrl)
        }
      }
    })])
  })) : _vm._e(), _vm._v(" "), (_vm.dataList.length == 0) ? _c('div', {
    staticClass: "footerdf"
  }, [_c('div', {
    staticClass: "footerdf-title"
  }, [_c('span', {
    staticClass: "footerdf-title-nick"
  }, [_vm._v(_vm._s(_vm.edition != 2 ? ' ' : _vm.ownername))]), _vm._v(" "), _c('span', {
    staticClass: "footerdf-title-txt"
  }, [_vm._v(_vm._s(_vm.edition == 1 ? '下载YY，获取更多精彩小视频！' : _vm.edition == 2 ? '邀请你一起欢乐狼人杀' : '下载吃瓜小视频 获取更多精彩'))])]), _vm._v(" "), _c('div', {
    staticClass: "footerdf-download",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.jumpLink(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.edition != 2 ? '下载' : '杀一局'))])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.edition == 1 ? 'footer-icon yy' : _vm.edition == 2 ? 'footer-icon lr' : 'footer-icon cg'
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-478c998e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Footer/Footer.vue
// module id = 24
// module chunks = 0